import { HttpErrorResponse } from "@angular/common/http";
import { catchError, map, Observable, of, retry, tap } from "rxjs";
import { ApiModel } from "src/app/infrastructure/lobby-proxy/DTOs/base-DTOs/api-model.dto";
import { ApiStatus } from "src/app/infrastructure/lobby-proxy/DTOs/base-DTOs/api-status.dto";
import { LobbyErrorCode } from "src/app/infrastructure/lobby-proxy/enums/lobby-error-code.enum";
import { LobbyError, LobbyErrors } from "../../../core/models/common/lobby-error.model";

export function throwIfLobbyErrorCode<T extends ApiModel>(httpCall$: Observable<T>): Observable<T> {
    return httpCall$.pipe(
        catchError((e: HttpErrorResponse) => {
            if (e.error?.['status']) throwLobbyError(e.error.status as ApiStatus);
            throw e
        }),
        map((dto) => {
            if (dto.status?.errorCode >= 2000) throwLobbyError(dto.status)
            return dto
        })
    )
}

export function throwIfLobbyStatusErrorCode<T extends ApiStatus>(httpCall$: Observable<T>): Observable<T> {
    return httpCall$.pipe(
        catchError((e: HttpErrorResponse) => {
            if (e.error?.['status']) throwLobbyError(e.error.status as ApiStatus);
            throw e
        }),
        map((status) => {
            if (status?.errorCode ?? 0 >= 2000) throwLobbyError(status)
            return status
        }
        )
    )
}

function throwLobbyError(status: ApiStatus): void {
    const errors = status.errors?.map(e => new LobbyError(LobbyErrorCode[e.code as keyof typeof LobbyErrorCode], undefined, e.message)) ?? []
    throw new LobbyErrors(LobbyErrorCode[status.errorCode.toString() as keyof typeof LobbyErrorCode], status.errorCategory.toString(), status.errorMessage, errors)
}









